import React, { useEffect, useMemo } from "react";

import { Box, Chip } from "@mui/material";

export default function BlogPostBlogPostCustomers({ blogPost }) {
  const customers = blogPost.customers;

  const displayedBlogPostCustomers = useMemo(() => {
    if (customers?.length) {
      return customers;
    }

    return [];
  }, [customers, blogPost]);

  return (
    <>
      <Box flexDirection="column" display="flex">
        <Box display="flex" gap={1} flexWrap="wrap">
          {blogPost.roles?.map((role) => (
            <Chip
              key={`role_${role.id}`}
              variant="outlined"
              size="small"
              label={role.name}
            />
          ))}
        </Box>

        <Box display="flex" gap={1} flexWrap="wrap">
          {displayedBlogPostCustomers.map((customer) => (
            <Chip
              key={customer.id}
              variant="outlined"
              size="small"
              label={customer.display_name}
            />
          ))}
        </Box>
      </Box>
    </>
  );
}
